import { AppButton } from 'components/form';
import React from 'react';
import { t } from 'utilities/TranslationUtils';

// AppSectionErrorBoundary that will catch any errors that occur in the section
// and display a friendly blurred background on the section indicating an error.
interface Props {
  children: React.ReactNode;
}

export class AppSectionErrorBoundary extends React.Component<Props> {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <div className='app-section-error-boundary  '>
            <div className='app-section-error-boundary__content '>
              <div className='app-section-error-boundary__background'></div>
              <div className='app-section-error-boundary__content__title'>{t('error.error_in_loading_section')}</div>

              <div className='app-section-error-boundary__content__message'>{t('error.something_went_wrong_please_refresh_the_page')}</div>

              <div className='app-section-error-boundary__content__message'>
                {t('error.if_the_problem_persists_please_contact_support')}
              </div>

              <AppButton className='mt-3' onClick={() => window.location.reload()}>
                {t('refresh')}
              </AppButton>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppSectionErrorBoundary;
